module.exports = __webpack_public_path__ + "img/h2.0ea4ea62.svg";